export class ImaActions {
    _isAdPlaying = false;
    _isReusingAdapter = false;
    adapter;
    muteStream = false;
    recoverVolume = null;
    constructor(adapter) {
        this.adapter = adapter;
    }
    isAdPlaying() {
        return this._isAdPlaying;
    }
    isReusingAdapter() {
        return this._isReusingAdapter;
    }
    static getInstance() {
        return this;
    }
    loadNewSession(muteStream) {
        if (this.recoverVolume !== null) {
            this.adapter.setVolume(this.recoverVolume);
        }
        this.muteStream = muteStream ?? false;
    }
    saveState() {
        if (this.muteStream) {
            this.recoverVolume = this.adapter.getVolume();
            this.adapter.setVolume(0);
        }
        else {
            this.adapter.pause();
        }
        this._isAdPlaying = true;
    }
    restoreState() {
        this._isAdPlaying = false;
        if (this.recoverVolume !== null) {
            this.adapter.setVolume(this.recoverVolume);
            this.recoverVolume = null;
        }
        if (!this.muteStream) {
            this.adapter.play();
        }
        return Promise.resolve();
    }
}
